import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getSubjectList } from '../../redux/sclassRelated/sclassHandle';
import { Container, Paper, Table, TableBody, TableHead, Typography, Tabs, Tab, Box, Card, CardContent, Grid } from '@mui/material';
import { getUserDetails } from '../../redux/userRelated/userHandle';
import CustomBarChart from '../../components/CustomBarChart'

import MenuBookIcon from '@mui/icons-material/MenuBook';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import TableChartIcon from '@mui/icons-material/TableChart';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { StyledTableCell, StyledTableRow } from '../../components/styles';

const StudentSubjects = () => {

    const dispatch = useDispatch();
    const { subjectsList, sclassDetails } = useSelector((state) => state.sclass);
    const { userDetails, currentUser, loading, response, error } = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(getUserDetails(currentUser._id, "Student"));
    }, [dispatch, currentUser._id])

    if (response) { console.log(response) }
    else if (error) { console.log(error) }

    const [subjectMarks, setSubjectMarks] = useState([]);
    const [selectedSection, setSelectedSection] = useState('table');

    useEffect(() => {
        if (userDetails) {
            setSubjectMarks(userDetails.examResult || []);
        }
    }, [userDetails])

    useEffect(() => {
        if (subjectMarks === []) {
            dispatch(getSubjectList(currentUser.sclassName._id, "ClassSubjects"));
        }
    }, [subjectMarks, dispatch, currentUser.sclassName._id]);

    const handleSectionChange = (event, newSection) => {
        setSelectedSection(newSection);
    };

    const renderTableSection = () => {
        return (
            <Card sx={{ mt: 3, borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                    <Box sx={{ p: 3, pb: 1 }}>
                        <Typography variant="h5" fontWeight="700" color="#1e293b">
                            Subject Marks
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Your performance across all registered subjects
                        </Typography>
                    </Box>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell sx={{ borderBottom: '2px solid #f1f5f9' }}>Subject Name</StyledTableCell>
                                <StyledTableCell sx={{ borderBottom: '2px solid #f1f5f9' }}>Marks Obtained</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {subjectMarks.map((result, index) => {
                                if (!result.subName || !result.marksObtained) {
                                    return null;
                                }
                                return (
                                    <StyledTableRow key={index} sx={{ '&:hover': { backgroundColor: 'rgba(241, 245, 249, 0.5)' } }}>
                                        <StyledTableCell sx={{ fontWeight: 600, color: '#334155', borderBottom: '1px solid #f1f5f9' }}>
                                            {result.subName.subName}
                                        </StyledTableCell>
                                        <StyledTableCell sx={{ fontWeight: 600, color: '#0f172a', borderBottom: '1px solid #f1f5f9' }}>
                                            {result.marksObtained}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        );
    };

    const renderChartSection = () => {
        return <CustomBarChart chartData={subjectMarks} dataKey="marksObtained" />;
    };

    const renderClassDetailsSection = () => {
        return (
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Box sx={{ mb: 4, textAlign: 'center' }}>
                    <Typography variant="h4" sx={{ fontWeight: '800', color: '#1e293b', mb: 1 }}>
                        Class Details
                    </Typography>
                    <Typography variant="subtitle1" sx={{ color: '#64748b' }}>
                        You are currently enrolled in Class <Box component="span" sx={{ fontWeight: 'bold', color: '#3b82f6' }}>{sclassDetails && sclassDetails.sclassName}</Box>
                    </Typography>
                </Box>
                
                <Grid container spacing={3}>
                    {subjectsList &&
                        subjectsList.map((subject, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card sx={{ 
                                    borderRadius: '16px', 
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    border: '1px solid rgba(0,0,0,0.04)',
                                    overflow: 'hidden',
                                    '&:hover': {
                                        transform: 'translateY(-5px)',
                                        boxShadow: '0 12px 30px rgba(0,0,0,0.08)'
                                    }
                                }}>
                                    <Box sx={{ 
                                        p: 3, 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: 2,
                                        background: 'linear-gradient(135deg, rgba(241, 245, 249, 1) 0%, rgba(255, 255, 255, 1) 100%)',
                                        borderBottom: '1px solid rgba(0,0,0,0.05)'
                                    }}>
                                        <Box sx={{ 
                                            p: 1.5, 
                                            borderRadius: '12px', 
                                            background: 'rgba(59, 130, 246, 0.1)',
                                            display: 'flex'
                                        }}>
                                            <MenuBookIcon sx={{ color: '#3b82f6', fontSize: 28 }} />
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" sx={{ fontWeight: '700', color: '#94a3b8', letterSpacing: '1px', textTransform: 'uppercase' }}>
                                                {subject.subCode}
                                            </Typography>
                                            <Typography variant="h6" sx={{ fontWeight: '700', color: '#1e293b', lineHeight: 1.2 }}>
                                                {subject.subName}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <CardContent sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="body2" sx={{ color: '#64748b', fontWeight: '500' }}>
                                            Status: Active
                                        </Typography>
                                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#10b981' }} />
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                </Grid>
            </Container>
        );
    };

    return (
        <>
            {loading ? (
                <div>Loading...</div>
            ) : (
                <div>
                    {subjectMarks && Array.isArray(subjectMarks) && subjectMarks.length > 0
                        ?
                        (<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                                <Tabs 
                                    value={selectedSection} 
                                    onChange={handleSectionChange} 
                                    textColor="primary"
                                    indicatorColor="primary"
                                    sx={{
                                        '& .MuiTab-root': { fontWeight: 600, textTransform: 'none', fontSize: '1rem' }
                                    }}
                                >
                                    <Tab label="Table View" value="table" icon={<TableChartIcon sx={{ mr: 1 }} />} iconPosition="start" />
                                    <Tab label="Chart View" value="chart" icon={<InsertChartIcon sx={{ mr: 1 }} />} iconPosition="start" />
                                </Tabs>
                            </Box>

                            {selectedSection === 'table' && renderTableSection()}
                            {selectedSection === 'chart' && (
                                <Card sx={{ mt: 3, borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', p: 3 }}>
                                    {renderChartSection()}
                                </Card>
                            )}
                        </Container>)
                        :
                        (<>
                            {renderClassDetailsSection()}
                        </>)
                    }
                </div>
            )}
        </>
    );
};

export default StudentSubjects;